var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_905_19670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.75H13.5V4.5C13.5 2.01825 11.4818 0 9 0C6.51825 0 4.5 2.01825 4.5 4.5V6.75H3.9375C3.0075 6.75 2.25 7.50675 2.25 8.4375V16.3125C2.25 17.2432 3.0075 18 3.9375 18H14.0625C14.9925 18 15.75 17.2432 15.75 16.3125V8.4375C15.75 7.50675 14.9925 6.75 14.0625 6.75ZM6 4.5C6 2.8455 7.3455 1.5 9 1.5C10.6545 1.5 12 2.8455 12 4.5V6.75H6V4.5ZM9.75 12.5415V14.25C9.75 14.664 9.41475 15 9 15C8.58525 15 8.25 14.664 8.25 14.25V12.5415C7.80375 12.2812 7.5 11.8027 7.5 11.25C7.5 10.4227 8.17275 9.75 9 9.75C9.82725 9.75 10.5 10.4227 10.5 11.25C10.5 11.8027 10.1962 12.2812 9.75 12.5415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_19670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.f118c92972d6071f6acce8d0a2c59c68.svg";
export { ForwardRef as ReactComponent };